import { render, staticRenderFns } from "./show.vue?vue&type=template&id=78c4ffbf&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c4ffbf')) {
      api.createRecord('78c4ffbf', component.options)
    } else {
      api.reload('78c4ffbf', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=78c4ffbf&", function () {
      api.rerender('78c4ffbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/show.vue"
export default component.exports